"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.88 22H5.12A3.12 3.12 0 0 1 2 18.88V5.12A3.12 3.12 0 0 1 5.12 2h13.76A3.12 3.12 0 0 1 22 5.12v13.76A3.12 3.12 0 0 1 18.88 22M5.12 3.28a1.84 1.84 0 0 0-1.84 1.84v13.76a1.84 1.84 0 0 0 1.84 1.84h13.76a1.84 1.84 0 0 0 1.84-1.84V5.12a1.84 1.84 0 0 0-1.84-1.84z",
        clipRule: "evenodd"
      }
    )
  }
), n = l(r);
export {
  n as Checkbox,
  n as default
};
